// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/artifacts/v1/contentgrant.proto (package chalk.artifacts.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/artifacts/v1/contentgrant.proto.
 */
export const file_chalk_artifacts_v1_contentgrant: GenFile = /*@__PURE__*/
  fileDesc("CiVjaGFsay9hcnRpZmFjdHMvdjEvY29udGVudGdyYW50LnByb3RvEhJjaGFsay5hcnRpZmFjdHMudjEiXQoMQ29udGVudEdyYW50EhEKB3VzZXJfaWQYASABKAlIABItCgRyb2xlGAMgASgOMh8uY2hhbGsuYXJ0aWZhY3RzLnYxLkNvbnRlbnRSb2xlQgsKCXByaW5jaXBhbCJEChBDb250ZW50R3JhbnRMaXN0EjAKBmdyYW50cxgBIAMoCzIgLmNoYWxrLmFydGlmYWN0cy52MS5Db250ZW50R3JhbnQifQoOQ29udGVudFNoYXJpbmcSOQoKdmlzaWJpbGl0eRgBIAEoDjIlLmNoYWxrLmFydGlmYWN0cy52MS5Db250ZW50VmlzaWJpbGl0eRIwCgZncmFudHMYAiADKAsyIC5jaGFsay5hcnRpZmFjdHMudjEuQ29udGVudEdyYW50Kn4KEUNvbnRlbnRWaXNpYmlsaXR5EiIKHkNPTlRFTlRfVklTSUJJTElUWV9VTlNQRUNJRklFRBAAEiIKHkNPTlRFTlRfVklTSUJJTElUWV9FTlZJUk9OTUVOVBABEiEKHUNPTlRFTlRfVklTSUJJTElUWV9SRVNUUklDVEVEEAIqdQoLQ29udGVudFJvbGUSHAoYQ09OVEVOVF9ST0xFX1VOU1BFQ0lGSUVEEAASFwoTQ09OVEVOVF9ST0xFX1ZJRVdFUhABEhcKE0NPTlRFTlRfUk9MRV9FRElUT1IQAhIWChJDT05URU5UX1JPTEVfT1dORVIQA2IGcHJvdG8z");

/**
 * One principal's access to one piece of content. The creator is an implicit owner, never listed.
 *
 * @generated from message chalk.artifacts.v1.ContentGrant
 */
export type ContentGrant = Message<"chalk.artifacts.v1.ContentGrant"> & {
  /**
   * A oneof so another principal kind can be added later without breaking the wire format.
   *
   * @generated from oneof chalk.artifacts.v1.ContentGrant.principal
   */
  principal: {
    /**
     * A team member's User.id.
     *
     * @generated from field: string user_id = 1;
     */
    value: string;
    case: "userId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: chalk.artifacts.v1.ContentRole role = 3;
   */
  role: ContentRole;
};

/**
 * Describes the message chalk.artifacts.v1.ContentGrant.
 * Use `create(ContentGrantSchema)` to create a new message.
 */
export const ContentGrantSchema: GenMessage<ContentGrant> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_contentgrant, 0);

/**
 * Wrapper so a grant list can be distinguished from an omitted one on update.
 *
 * @generated from message chalk.artifacts.v1.ContentGrantList
 */
export type ContentGrantList = Message<"chalk.artifacts.v1.ContentGrantList"> & {
  /**
   * @generated from field: repeated chalk.artifacts.v1.ContentGrant grants = 1;
   */
  grants: ContentGrant[];
};

/**
 * Describes the message chalk.artifacts.v1.ContentGrantList.
 * Use `create(ContentGrantListSchema)` to create a new message.
 */
export const ContentGrantListSchema: GenMessage<ContentGrantList> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_contentgrant, 1);

/**
 * One piece of content's access control: its visibility plus the grants that apply when restricted.
 *
 * @generated from message chalk.artifacts.v1.ContentSharing
 */
export type ContentSharing = Message<"chalk.artifacts.v1.ContentSharing"> & {
  /**
   * @generated from field: chalk.artifacts.v1.ContentVisibility visibility = 1;
   */
  visibility: ContentVisibility;

  /**
   * Always empty for ENVIRONMENT content, which grants access by permission.
   *
   * @generated from field: repeated chalk.artifacts.v1.ContentGrant grants = 2;
   */
  grants: ContentGrant[];
};

/**
 * Describes the message chalk.artifacts.v1.ContentSharing.
 * Use `create(ContentSharingSchema)` to create a new message.
 */
export const ContentSharingSchema: GenMessage<ContentSharing> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_contentgrant, 2);

/**
 * Who can reach one piece of content. Server-owned; never written through the artifact.
 *
 * @generated from enum chalk.artifacts.v1.ContentVisibility
 */
export enum ContentVisibility {
  /**
   * @generated from enum value: CONTENT_VISIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Everyone in the environment holding the content type's read permission.
   *
   * @generated from enum value: CONTENT_VISIBILITY_ENVIRONMENT = 1;
   */
  ENVIRONMENT = 1,

  /**
   * Only the creator and the principals in the content's grants.
   *
   * @generated from enum value: CONTENT_VISIBILITY_RESTRICTED = 2;
   */
  RESTRICTED = 2,
}

/**
 * Describes the enum chalk.artifacts.v1.ContentVisibility.
 */
export const ContentVisibilitySchema: GenEnum<ContentVisibility> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_contentgrant, 0);

/**
 * What a caller may do with one piece of content; ordered, so overlapping grants resolve to the max.
 *
 * @generated from enum chalk.artifacts.v1.ContentRole
 */
export enum ContentRole {
  /**
   * @generated from enum value: CONTENT_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Read and export.
   *
   * @generated from enum value: CONTENT_ROLE_VIEWER = 1;
   */
  VIEWER = 1,

  /**
   * Also rename, edit, delete.
   *
   * @generated from enum value: CONTENT_ROLE_EDITOR = 2;
   */
  EDITOR = 2,

  /**
   * Also change visibility and grants.
   *
   * @generated from enum value: CONTENT_ROLE_OWNER = 3;
   */
  OWNER = 3,
}

/**
 * Describes the enum chalk.artifacts.v1.ContentRole.
 */
export const ContentRoleSchema: GenEnum<ContentRole> = /*@__PURE__*/
  enumDesc(file_chalk_artifacts_v1_contentgrant, 1);

